"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@dnd-kit/core");
var _modifiers = require("@dnd-kit/modifiers");
var _sortable = require("@dnd-kit/sortable");
function HBTableDndProvider(_ref) {
  var table = _ref.table,
    onColumnOrderChange = _ref.onColumnOrderChange,
    children = _ref.children;
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.PointerSensor, {
    activationConstraint: {
      distance: 3
    }
  }));
  var handleDragEnd = function handleDragEnd(event) {
    var _over$data;
    var active = event.active,
      over = event.over;
    if (!over || active.id === over.id) {
      return;
    }
    var currentOrder = table.getState().columnOrder;
    var oldIndex = currentOrder.indexOf(String(active.id));
    var newIndex = (_over$data = over.data) === null || _over$data === void 0 || (_over$data = _over$data.current) === null || _over$data === void 0 ? void 0 : _over$data.overIndex;
    var newOrder = (0, _sortable.arrayMove)(currentOrder, oldIndex, newIndex);
    table.setColumnOrder(newOrder);
    table.options.state.columnOrder = newOrder;
    onColumnOrderChange === null || onColumnOrderChange === void 0 || onColumnOrderChange(newOrder);
  };
  var columnIds = table.getState().columnOrder;
  return /*#__PURE__*/_react["default"].createElement(_core.DndContext, {
    onDragEnd: handleDragEnd,
    sensors: sensors,
    modifiers: [_modifiers.restrictToHorizontalAxis],
    autoScroll: {
      threshold: {
        x: 0,
        y: 0
      },
      acceleration: 10
    }
  }, /*#__PURE__*/_react["default"].createElement(_sortable.SortableContext, {
    items: columnIds,
    strategy: _sortable.horizontalListSortingStrategy
  }, children));
}
var _default = exports["default"] = HBTableDndProvider;
//# sourceMappingURL=HBTableDndProvider.js.map